import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Text } from '@/Components/Preferences/PreferencesComponents/Content';
import { c } from 'ttag';
const SharingStatusText = ({ subscriptionState }) => {
    const { usedInvitationsCount, allowedInvitationsCount } = subscriptionState;
    return (_jsxs(Text, { className: "mt-1", children: [c('B6.Preferences.Subscription.Info').t `You've used`, " ", _jsx("span", { className: "font-bold", children: usedInvitationsCount }), ' ', c('B6.Preferences.Subscription.Info').t `out of`, " ", allowedInvitationsCount, ' ', c('B6.Preferences.Subscription.Info').t `subscription invites.`] }));
};
export default observer(SharingStatusText);
